// extracted by mini-css-extract-plugin
module.exports = {"CommentListPlaceholder":"if_a bhb_je","CommentListPlaceholder--Legacy":"if_b bhb_qh bhb_vk"};